import React, { useMemo } from 'react';
import {
  AllToolsSideNavLinkWrapper,
  AllToolsSideNavLinkInnerWrapper,
  AllToolsNavWrapper,
} from './styles';
import { SvgIcon } from 'src/commons/components/SvgIcon/SvgIcon';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { SideNavLinkTitleWrapper } from '../styles';
import SideNavLinkFeatures from '../SideNavLinkFeatures/SideNavLinkFeatures';

interface AllToolsSideNavLinkProps {
  id: string;
  isFromAllTools?: boolean;
  isQuickNavModalEnabled?: boolean;
}

const AllToolsSideNavLink: React.VFC<AllToolsSideNavLinkProps> = ({ id }) => {
  const { toolbarItems } = useConsolidatedNavContext();

  const toolbarItem = useMemo(
    () => toolbarItems.find((toolbarItem) => toolbarItem.id === id),
    [toolbarItems],
  );

  if (!toolbarItem) {
    return null;
  }

  const { link, id: linkId } = toolbarItem.sidebarGroups[0].links[0];
  const { label: title, url } = link;

  return (
    <AllToolsSideNavLinkWrapper>
      <AllToolsSideNavLinkInnerWrapper
        isSelected={false}
        href={url}
        data-ccx-e2e-id={linkId}
        aria-label={title}
        {...getTaktAttributes(linkId, chromeComponents.ALL_TOOLS_NAV, {
          url: url,
        })}
      >
        <SvgIcon
          iconPath={toolbarItem.iconPath}
          ariaLabel={title}
          isSelected={false}
        />
        <AllToolsNavWrapper>
          <SideNavLinkTitleWrapper>{title}</SideNavLinkTitleWrapper>
          <SideNavLinkFeatures
            sideNavLink={toolbarItem.sidebarGroups[0].links[0]}
            displayLandingApp={false}
          />
        </AllToolsNavWrapper>
      </AllToolsSideNavLinkInnerWrapper>
    </AllToolsSideNavLinkWrapper>
  );
};

export default AllToolsSideNavLink;
